import MySavings from './MySavings'

export default MySavings
